import getIgniteService from './getIgniteService';

export default function getAnswerService() {
  return getIgniteService('answerService');
}
